import React, { useContext, useState } from 'react';
import Card from '../card/Card';
import cardContext from '../../context/cards/cardContext';
import './ShowCard.css';
import { Sheet } from 'react-modal-sheet';

const ShowCard = ({ sectionList }) => {
  const { cardData } = useContext(cardContext);
  const [selectedCard, setSelectedCard] = useState(null);
  const [quantities, setQuantities] = useState({});
  const [isOpenBottomSheet, setOpenBottomSheet] = useState(false);

  const handleQuantityChange = (id, change) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: Math.max((prev[id] || 0) + change, 0),
    }));
  };

  const openBottomSheet = (card) => {
    setSelectedCard(card);
    setOpenBottomSheet(true);
  };

  const closeBottomSheet = () => {
    setSelectedCard(null);
    setOpenBottomSheet(false);
  };

  return (
    <div>
      {sectionList.map(({ id, name }) => (
        <section key={id} id={id} className="content-section">
          <h2>{name}</h2>
          <div className="card-grid">
            {cardData
              .filter((card) => card.category === id)
              .map((card) => (
                <Card
                  key={card.id}
                  card={card}
                  onQuantityChange={handleQuantityChange}
                  onOpenDetails={openBottomSheet}
                />
              ))}
          </div>
        </section>
      ))}

      {/* Cursive rastaura text at bottom */}
      <div className="rastaura-signature">
        <i>powered by rastaura</i>
      </div>

      <Sheet 
        isOpen={isOpenBottomSheet} 
        onClose={closeBottomSheet}
        disableScrollLocking={true}
        detent='content'
      >
        <Sheet.Container>
          <Sheet.Header>
            <div className="sheet-header">
              <h2></h2>
              <button className="close-btn" onClick={closeBottomSheet}>
                ×
              </button>
            </div>
          </Sheet.Header>
          <Sheet.Content>
            {selectedCard && (
              <div className="sheet-content">
                <img
                  src={selectedCard.image}
                  alt={selectedCard.name}
                  className="sheet-image"
                />
                <h2>{selectedCard.name}</h2>
                <p>{selectedCard.description}</p>
                <p className="sheet-price">Price: ₹{selectedCard.price}</p>
              </div>
            )}
          </Sheet.Content>
        </Sheet.Container>
        <Sheet.Backdrop onTap={closeBottomSheet} />
      </Sheet>
    </div>
  );
};

export default ShowCard;
